export var HeadsetEvents;
(function (HeadsetEvents) {
    HeadsetEvents["implementationChanged"] = "implementationChanged";
    HeadsetEvents["deviceHoldStatusChanged"] = "deviceHoldStatusChanged";
    HeadsetEvents["deviceMuteStatusChanged"] = "deviceMuteStatusChanged";
    HeadsetEvents["deviceAnsweredCall"] = "deviceAnsweredCall";
    HeadsetEvents["deviceEndedCall"] = "deviceEndedCall";
    HeadsetEvents["deviceRejectedCall"] = "deviceRejectedCall";
    HeadsetEvents["loggableEvent"] = "loggableEvent";
    HeadsetEvents["webHidPermissionRequested"] = "webHidPermissionRequested";
    HeadsetEvents["deviceConnectionStatusChanged"] = "deviceConnectionStatusChanged";
    HeadsetEvents["deviceEventLogs"] = "deviceEventLogs";
})(HeadsetEvents || (HeadsetEvents = {}));
//# sourceMappingURL=consumed-headset-events.js.map